import {
  AUTH_INIT_LOGIN, AUTH_LOGIN_SUCCESS, AUTH_LOGIN_FAILURE, AUTH_LOGOUT,
} from './types/authActionTypes';

export function initLoginAction(username, password) {
  return {
    type: AUTH_INIT_LOGIN,
    payload: {
      username,
      password,
    },
  };
}

export function loginFailedAction(error) {
  return {
    type: AUTH_LOGIN_FAILURE,
    payload: {
      error,
    },
  };
}

export function loginSucceededAction(token) {
  return {
    type: AUTH_LOGIN_SUCCESS,
    payload: {
      token,
    },
  };
}

export function logoutAction() {
  return {
    type: AUTH_LOGOUT,
    payload: '',
  };
}
